import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OAuthenticationService } from 'src/app/shared/authentication/oauthentication.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NavigationService } from '../../../shared/store/navigation/navigation.service';

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  host: { class: 'connection-form p-4 col-12 col-sm-8' },
  standalone: false,
})
export class LoginComponent {
  isAuthenticated = false;
  checkSessionChanged$: Observable<boolean>;
  checkSessionChanged: any;
  result: Promise<Object>;
  returnUrl: string;
  showErrorLogin: boolean;
  loginForm: FormGroup;

  constructor(
    private readonly authService: OAuthenticationService,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly navigationService: NavigationService,
    protected readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.navigationService.getModules.reset();
    this.navigationService.getMenus.reset();

    this.loginForm = this.formBuilder.group({
      rememberMe: [false],
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.authService
      .loginWithCredentials({
        mail: this.loginForm.value.email!,
        password: this.loginForm.value.password!,
      })
      .then((x) => {
        //remember me ?

        // returnUrl prioritaire ; sinon root ('/') : le HomeRedirectGuard
        // résout la première page réellement accessible (source unique).
        this.router.navigateByUrl(this.returnUrl ?? '/');
      })
      .catch((x) => {
        this.showErrorLogin = true;
        // console.log(x);
      });
  }

  get email() {
    return this.loginForm.get('email')!;
  }

  get password() {
    return this.loginForm.get('password')!;
  }
}
